import request from "@/utils/request";

export const news = {
  // 列表
  list: (params) =>
    request({
      url: "/api/backend/operation/news/list",
      method: "GET",
      params,
    }),
  // 添加
  create: (form) =>
    request({
      url: "/api/backend/operation/news/add",
      method: "POST",
      data: { ...form },
    }),
  // 上下架
  changeState: (id) =>
    request({
      url: "/api/backend/operation/news/state",
      method: "POST",
      data: { id },
    }),
  delEvent: (id) =>
    request({
      url: "/api/backend/operation/news/del",
      method: "POST",
      data: { id },
    }),
};

// 通知管理
export const notification = {
  // 列表
  list: (params) =>
    request({
      url: "/api/backend/operation/notice/list",
      method: "GET",
      params,
    }),
  // 添加
  create: (form) =>
    request({
      url: "/api/backend/operation/notice/add",
      method: "POST",
      data: { ...form },
    }),
  // 上下架
  changeState: (id) =>
    request({
      url: "/api/backend/operation/notice/state",
      method: "POST",
      data: {
        id,
      },
    }),
  delete: (id) =>
    request({
      url: "/api/backend/operation/notice/del",
      method: "POST",
      data: {
        id,
      },
    }),
};

export const banner = {
  createBanner: (data) =>
    request({
      url: "/api/backend/banners/store",
      method: "POST",
      data,
    }),
  bannerList: (category_id) =>
    request({
      url: "/api/backend/banners",
      method: "GET",
      params: { category_id },
    }),
  modalData: () =>
    request({
      url: "/api/backend/banners/get/tanChuang",
      method: "GET",
    }),
  navigationType: (link_type, link_to) =>
    request({
      url: "/api/backend/banners/link_type",
      method: "GET",
      params: { link_type, link_to },
    }),
  state: (data) =>
    request({
      url: "/api/backend/banners/state",
      method: "POST",
      data,
    }),
};

export const alert = {
  get: () =>
    request({
      url: "/api/backend/banners/get/tanChuang",
      method: "GET",
    }),
  set: (data) =>
    request({
      url: "/api/backend/banners/tanChuang",
      method: "POST",
      data,
    }),
};

export const channel = {
  list: (params) =>
    request({
      url: "/api/backend/operation/channel/index",
      method: "GET",
      params
    }),
  add: (data) =>
    request({
      url: "/api/backend/operation/channel/add",
      method: "POST",
      data
    }),
  getWXMiniCode: (data) =>
    request({
      url: "/api/backend/operation/channel/wxMiniCode",
      method: "POST",
      data
    }),
  lowerList: (params) =>
    request({
      url: "/api/backend/operation/channel/list",
      method: "GET",
      params
    }),
};
